export const converterBlobParaJson = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function () {
      try {
        const jsonObj = JSON.parse(reader.result);
        resolve(jsonObj);
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.readAsText(blob);
  });
};
